import React, { useState, useEffect, useCallback } from "react";
import { Link } from "gatsby";
import Button from "../button";
import ManageCookiesModal from "./ManageCookiesModal";
import * as SC from "./style";
import {
  getCookieSettings,
  acceptAllCookiesSettings,
  rejectNonEssentialCookiesSettings,
  manageCookies,
} from "./CookiesSettings";

const Cookies = () => {
  const [cookies, setCookies] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const settings = getCookieSettings();
    if (!settings) setCookies(false);
    else manageCookies(settings);
  });

  const accepAllCookies = () => {
    acceptAllCookiesSettings();
    setCookies(true);
  };

  const rejectNonEssentialCookies = () => {
    rejectNonEssentialCookiesSettings();
    setCookies(true);
  };

  const handleCloseModal = useCallback(() => {
    setCookies(true);
    if (openModal) setOpenModal(false);
  }, [openModal]);

  return cookies ? null : (
    <React.Fragment>
      {!openModal && (
        <SC.Container>
          <SC.subtitle>Cookies</SC.subtitle>
          <div>
            We use cookies to optimize your experience and site performance.
            Essential cookies are always active, while a small number of
            analytics and marketing cookies are used to help us learn how to
            improve the site.{" "}
            <Link to={"/cookie-information"}>Cookie Policy</Link>
          </div>
          <SC.ButtonContainer>
            <Button
              text="make cookie choices"
              color="fff"
              bordercolor="fff"
              onClick={() => setOpenModal(true)}
              hovercolor="282828"
              hoverbackcolor="fff"
              style={{ flex: 1 }}
            />

            <Button
              text="reject all non-essential cookies"
              color="fff"
              bordercolor="fff"
              hovercolor="282828"
              hoverbackcolor="fff"
              onClick={rejectNonEssentialCookies}
            />

            <SC.Button onClick={accepAllCookies}>accept all cookies</SC.Button>
          </SC.ButtonContainer>
        </SC.Container>
      )}

      <ManageCookiesModal open={openModal} onClose={handleCloseModal} />
    </React.Fragment>
  );
};

export default Cookies;
